import { createFileRoute } from "@tanstack/react-router";
import { applyAuthGuard } from "@/routes/-auth-guard";
import ClientDashboardResolver from "@/app/dashboard/client-dashboard-resolver";

export const Route = createFileRoute("/dashboard/")({
  beforeLoad: ({ location }) =>
    applyAuthGuard(location.pathname, new URLSearchParams(location.searchStr)),
  component: ClientDashboardResolver,
});
